import React from 'react';
import TopA from './Lp/pattern-a/TopA';
import { useScrollToTop } from '../hooks/useScrollToTop';

const Top = () => {
  useScrollToTop();
  return <TopA />;
};

export default Top;
